import { render, staticRenderFns } from "./close-icon.vue?vue&type=template&id=299501fd&scoped=true&lang=pug&"
import script from "./close-icon.vue?vue&type=script&lang=js&"
export * from "./close-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299501fd",
  null
  
)

export default component.exports